import GLightbox from "glightbox";

export default () => {
    const postsWrap = document.querySelector('.infinite__wrap');

    if (!postsWrap) return;


    const loader = document.getElementById('infinite-scroll-loader');

    let currentPage = parseInt(postsWrap.dataset.paged);
    const totalPages = parseInt(postsWrap.dataset.totalPages);

    let isLoading = false;

    document.querySelector('.infinite__wrap').dataset

    function loadMorePosts() {

        if (isLoading) return;
        if (currentPage >= totalPages) return;

        isLoading = true;

        loader.style.display = 'block';

        const nextPage = currentPage + 1;

        const params = new URLSearchParams();

        const isCategoryPage = postsWrap.classList.contains('infinite__wrap');

        params.append(
            'action',
            isCategoryPage ? 'load_more_category_posts' : 'load_more_blog_posts'
        );

        params.append('paged', nextPage);

        params.append(
            'nonce',
            document.querySelector('input[name="load_more_posts_nonce"]').value
        );

        if (isCategoryPage) {

            params.append('category', postsWrap.dataset.category);

            if (postsWrap.dataset.year)
                params.append('year', postsWrap.dataset.year);

            if (postsWrap.dataset.excludePostId)
                params.append('exclude_post_id', postsWrap.dataset.excludePostId);

        } else {

            if (postsWrap.dataset.category)
                params.append('blog_category', postsWrap.dataset.category);

            if (postsWrap.dataset.year)
                params.append('blog_year', postsWrap.dataset.year);

            if (postsWrap.dataset.excludePostId)
                params.append('exclude_post_id', postsWrap.dataset.excludePostId);

        }

        fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: params
        })
            .then(res => res.json())
            .then(data => {

                loader.style.display = 'none';

                isLoading = false;

                if (!data.success) return;

                postsWrap.insertAdjacentHTML('beforeend', data.data.html);

                currentPage++;

            })
            .catch(() => {

                loader.style.display = 'none';

                isLoading = false;

            });

    }

    window.addEventListener('scroll', () => {

        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 300) {
            console.log('loading');
            loadMorePosts();

        }

    });
};
